import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const tips = [
  'economiser_1',
  'economiser_2',
  'economiser_3',
  'economiser_4',
  'economiser_5',
];

export default function Economiser() {
  const { t } = useTranslation('blogprix');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="economiser" className="scroll-mt-28">
      <h2 className={`font-manrope font-bold text-slate-primary text-xl md:text-2xl lg:text-3xl mb-8 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        {t('economiser_h2')}
      </h2>

      <div className="space-y-4">
        {tips.map((tip, idx) => (
          <div
            key={idx}
            className={`flex gap-4 bg-soft-gray rounded-lg p-4 md:p-5 transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDelay: `${idx * 100 + 150}ms` }}
          >
            <div className="w-8 h-8 shrink-0 flex items-center justify-center rounded-full bg-copper text-white font-bold text-sm">
              {idx + 1}
            </div>
            <p className="text-slate-primary/70 text-sm md:text-base leading-relaxed">{t(tip)}</p>
          </div>
        ))}
      </div>
    </section>
  );
}